
import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import { DynamicDataAttributes, DynamicField } from "@/types/dynamic-data";
import { configStore } from "@/store/store-accessor";
import lodash from "lodash";
import { ControlsTreeContext } from "@/types/controls";
import {
  getDynamicDataFieldAttributesAccordionState,
  setDynamicDataFieldAttributesAccordionState
} from "@/lib/panels/accordions";
import NiceButton from "@/components/UI/NiceButton.vue";
import defensiveCopy from "@/util/defensive-copy";

@Component({
  components: { NiceButton }
})
export default class DynamicDataFieldAttributes extends Vue {
  @Prop()
  value!: DynamicField;

  @Prop()
  attributes!: DynamicDataAttributes;

  get controlValues() {
    return {
      attributes: this.attributes
    };
  }

  @Provide("context")
  controlsContext: ControlsTreeContext = {
    dynamicProperty: () => false,
    getControls: () => configStore.selectorControls,
    getControlValue: controlPath => {
      return lodash.get(this.controlValues, controlPath);
    },
    setControlValue: (controlPath, newValue) => {
      const controlValues = defensiveCopy(this.controlValues);
      lodash.set(controlValues, controlPath, newValue);
      this.$set(this.controlValues, "attributes", controlValues.attributes);
      this.setControlValues(controlValues.attributes);
    },
    setAccordionState: (accordionPath: string, open: boolean) => {
      setDynamicDataFieldAttributesAccordionState(accordionPath, open);
    },
    getAccordionState: (accordionPath: string) => {
      return getDynamicDataFieldAttributesAccordionState(accordionPath);
    }
  };

  beforeCreate() {
    // @ts-ignore
    this.$options.components.ControlsTree =
      require("@/components/Reusable/ControlsTree/ControlsTree.vue").default;
  }

  setControlValues(attributes: DynamicDataAttributes) {
    this.$emit("input", attributes);
  }
}
